// plugins/vuetify.js
import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

//import { VTimeline, VTimelineItem, VTimelineDivider } from 'vuetify/labs/VTimeline'
//import { VTimeline, VTimelineItem, VTimelineDivider } from 'vuetify/labs/components'
import {
  VStepperVertical,
  VStepperVerticalItem,
  VStepperVerticalActions,
} from 'vuetify/labs/components'

//const vuetify = createVuetify()

/*const vuetify = createVuetify({
    components,
    directives,
})*/

const vuetify = createVuetify({
    components: {
        ...components,
        VStepperVertical,
        VStepperVerticalItem,
        VStepperVerticalActions,
    },
    directives,
})

export default vuetify
